import React from 'react';
import { useService } from '@xstate/react';
import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { getBaseProduct } from '../../../helpers/getBaseProduct';
import { getBaseProductType } from '../../../helpers/getBaseProductType';
import { getProductStateConfig } from '../../../helpers/getProductStateConfig';
import { ProductBuilderMachineEvent } from '../../../types';
import { Caption } from '../../Common/Caption';
import { Heading } from '../../Common/Heading';
import { Selector, SelectorImageItem } from '../../Common/Selector';
import { SectionContent } from './SectionContent';

type OnClick = (
  option: string,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (option, send) => () => {
  const customUpdate: any = {
    wand_option: option,
  };
  
  // If selecting "No", set wand colour to white but clear variant fields
  if (option === 'No') {
    customUpdate.wand_colour = 'white';
    customUpdate.wand_colour_variant_id = undefined;
    customUpdate.wand_colour_price = 0;
  }
  
  send({
    type: 'UPDATE_CUSTOM',
    custom: customUpdate,
  });
};

export const WandOption = () => {
  const [state, send] = useService(productBuilderMachine);
  const baseProduct = getBaseProduct(state.context);

  const wandOptions = ['No', 'Yes'];
  const { custom } = state.context;
  const productType = getBaseProductType(state.context);

  // Ensure default is "No" if no selection exists (including empty string)
  React.useLayoutEffect(() => {
    if (
      !('wand_option' in custom) ||
      custom.wand_option === undefined ||
      custom.wand_option === null ||
      custom.wand_option === ''
    ) {
      send({
        type: 'UPDATE_CUSTOM',
        custom: {
          wand_option: 'No',
          wand_colour: 'white',
          wand_colour_variant_id: undefined as any,
          wand_colour_price: 0 as any,
        },
      });
    }
  }, [send]);

  // Use the value from state, defaulting to 'No' for display purposes
  const currentSelection = custom.wand_option || 'No';

  return (
    <SectionContent>
      <Heading>Wand Option</Heading>
      <Caption>
        Choose whether to include a wand for operating your curtains.
      </Caption>
      <Selector isSlider={false}>
        {wandOptions.map(option => {
          const { showIcon, Icon, description } = getProductStateConfig(
            productType,
            'wand_option',
            option,
          );
          return (
            <SelectorImageItem
              isSelected={option === currentSelection}
              onClick={onClick(option, send)}
              showIcon={showIcon}
              Icon={Icon}
              title={option}
              key={option}
              description={description}
            />
          );
        })}
      </Selector>
    </SectionContent>
  );
};